import React, { useEffect, useState, Suspense } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Table, Avatar, Row, Col, message, Checkbox, Tag, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import util from '../../util/util'
import '../../css/users.scss'
import {
  fetchUsers,
  sendResetPasswordLink,
  deleteUser,
} from '../../store/action/user.action'
import { constants } from '../../constants'

const { ROLE } = constants

const UserTable = (props) => {
  var history = useHistory()
  useEffect(() => {
    fetchUsersList(
      { current: 1, pageSize: 20 },
      { order: 'ascend', field: 'surgery' }
    )
  }, [])

  var fetchUsersList = (pagination, sorter) => {
    props.fetchUsers({
      companyid: props.company?._id,
      customerid: props.customer?._id,
      pagination,
      searchText: props.searchText,
      sorter,
      active: props.active,
      onlyusers: true,
    })
  }

  var formatdata = (data) => {
    data && data.forEach((e, i) => (e.key = e._id))
    return data
  }

  var dataSource = formatdata(props.users)
  var pagination = {
    ...props.pagination,
    showSizeChanger: true,
  }

  var renderName = (name, obj) => {
    return (
      <Row className={'nameRow'}>
        <Avatar src={obj?.userimage}>{obj?.firstname[0]?.toUpperCase()}</Avatar>
        <span>
          {_.upperFirst(obj.firstname)}&nbsp;{_.upperFirst(obj.lastname)}
        </span>
      </Row>
    )
  }

  var handleRowClick = (record) =>
    history.push({ pathname: (props.back || 'user') + '/edit', state: record })
  var handleRow = (record, rowIndex) => {
    return {
      onClick: () => handleRowClick(record),
    }
  }

  var handleResetClick = (e, record) => {
    e.stopPropagation()
    props.resetPassword(record._id)
  }

  var handleEditClick = (e, record) => {
    e.stopPropagation()
    handleRowClick(record)
  }

  var handleDeleteClick = (e, record) => {
    e.stopPropagation()
    Modal.confirm({
      title: 'Delete user',
      icon: <ExclamationCircleOutlined />,
      content:
        'Are you sure you want to permanently delete ' +
        _.upperFirst(record.firstname) +
        ' ' +
        _.upperFirst(record.lastname) +
        '? This cannot be undone.',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        var response = await props.deleteUser(record._id)
        if (response) fetchUsersList()
      },
    })
  }

  var renderRole = (role) => {
    if (role == ROLE.ADMIN) return <Tag color='magenta'>ADMIN</Tag>
    if (role == ROLE.COMPANY_HEALTHCOACH)
      return <Tag color='yellow'>HEALTH COACH</Tag>
    if (role == ROLE.COMPANY_ADMIN)
      return <Tag color='yellow'>COMPANY ADMIN</Tag>
    if (role == ROLE.PHYSIO) return <Tag color='orange'>THERAPIST</Tag>
    if (role == ROLE.MEDICAL_ASSOCIATE)
      return <Tag color='orange'>MEDICAL ASSOCIATE</Tag>
    if (role == ROLE.SURGEON) return <Tag color='geekblue'>PROVIDER</Tag>
    if (role == ROLE.SUPER_ADMIN) return <Tag color='red'>SUPER ADMIN</Tag>
  }

  const columns = [
    {
      title: 'NAME',
      render: (name, obj) => renderName(name, obj),
    },
    {
      title: 'EMAIL',
      dataIndex: 'email',
      align: 'center',
    },
    {
      title: 'ROLE',
      dataIndex: 'role',
      align: 'center',
      render: renderRole,
    },
    {
      title: 'STATUS',
      dataIndex: 'active',
      align: 'center',
      render: (active, obj) => (active ? 'ACTIVE' : 'INACTIVE'),
    },
    {
      title: 'ACTION',
      align: 'center',
      render: (row, obj) => (
        <Row justify={'center'} align={'middle'} gutter={16}>
          {props.showActions && (
            <Col>
              <a id={'edituser'} onClick={(e) => handleEditClick(e, obj)}>
                Edit
              </a>
            </Col>
          )}
          <Col>
            <a id={'resetuserpass'} onClick={(e) => handleResetClick(e, obj)}>
              Reset Password
            </a>
          </Col>
          {props.showActions && (
            <Col>
              <a
                id={'deleteuser'}
                style={{ color: '#ff4d4f' }}
                onClick={(e) => handleDeleteClick(e, obj)}
              >
                Delete
              </a>
            </Col>
          )}
        </Row>
      ),
    },
  ]

  const components = {
    table: (props) => <table {...props} />,
    header: {
      wrapper: (props) => <thead id='userlist' {...props} />,
    },
  }

  return (
    <>
      <Table
        size={'large'}
        className={'custom-table'}
        columns={columns}
        dataSource={dataSource}
        loading={props.isLoading}
        pagination={pagination}
        onChange={fetchUsersList}
        bordered={false}
        onRow={handleRow}
        components={components}
      />
    </>
  )
}

UserTable.propTypes = {
  fetchSurgeon: PropTypes.func.isRequired,
  surgeons: PropTypes.array,
  sorter: PropTypes.object,
  searchText: PropTypes.string,
  pagination: PropTypes.object,
  isLoading: PropTypes.bool,
  selectedSurgeons: PropTypes.array,
  active: PropTypes.bool,
  user: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    users: state.user.users,
    user: state.profile.user,
    company: state.profile.company,
    sorter: state.user.sorter,
    searchText: state.user.searchText,
    pagination: state.user.pagination,
    active: state.user.active,
    isLoading: state.user.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUsers: (params) => dispatch(fetchUsers(params)),
    resetPassword: (id) => dispatch(sendResetPasswordLink(id)),
    deleteUser: (id) => dispatch(deleteUser(id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserTable)
